export default function dialog({ borders, colors }) {
  const { borderRadius } = borders;
  const { grey, background } = colors;

  const dialog = {
    styleOverrides: {
      paper: {
        borderRadius: borderRadius.xl,
        boxShadow: `0 24px 48px -12px rgba(0, 0, 0, 0.18), 0 0 0 1px ${grey[200]}`,
        backgroundColor: background.paper,
        overflow: "hidden",
      },

      paperFullScreen: {
        borderRadius: 0,
      },
    },
  };

  return dialog;
}
